<template>
  <v-app>
   
    <template>
      <v-container>
        <v-flex xs12>
     <v-breadcrumbs large :items="items" divider=">"></v-breadcrumbs>
     </v-flex>
        <v-toolbar flat color="white">
          <v-toolbar-title>Manage Locations</v-toolbar-title>
          <v-divider class="mx-2" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn @click="addLocationdialog = !addLocationdialog" color="primary" dark class="mb-2">New Location</v-btn>
        </v-toolbar>

        <v-data-table :headers="headers" :items="LocationsFromDB" class="elevation-1">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.createdDate }}</td>
            <td>{{ props.item.customer }}</td>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.status }}</td>
            <td>{{ props.item.desc }}</td>
            <td>{{ totalAsset(props.item.assets) }}</td>
            <td class="justify-center layout px-0">
              <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
              <v-icon small @click.stop="deleteDialog = true;name=props.item.name">build</v-icon>
            </td>
          </template>
        </v-data-table>

        <v-dialog v-model="deleteDialog" max-width="290">
          <v-card>
            <v-card-title style="color:red" class="headline">Delete</v-card-title>
            <v-card-text>Are you sure you want to delete location: {{name}} ?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="primary" flat="flat" @click="deleteDialog = false">Cancel</v-btn>

              <v-btn
                color="primary"
                flat="flat"
                @click="deleteDialog = false; deleteItem(name)"
              >Delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </template>

  </v-app>
</template>


<script>
const fb = require("../firebaseConfig.js");
import { mapFields } from "vuex-map-fields"; 

export default {
  name: "Locations",
  components: {
  },
  data() {
    return {
             items: [
        {
          text: 'Home',
          disabled: false,
          to: 'home'
        },
        {
          text: 'Locations',
          disabled: false,
          to: 'location'
        },
      ],
      messages: [],
      name: null,
      deleteDialog: false,
      currentOBJ: null,
      headers: [
        { text: "Created", value: "createdDate" },
        { text: "Customer", value: "customer" },
        { text: "Name", value: "name" },
        { text: "Status", value: "status" },
        { text: "Description", value: "desc" },
        { text: "# of Asset", value: "totalAsset" },
        { text: "Actions", value: "", sortable: false }
      ],
      LocationsFromDB: [],
    };
  },
  computed: {
    ...mapFields(["snackBarMessage",
        "snackBar","snackBarcolor","addLocationdialog"])
  },
  methods: {
    totalAsset: function(arr) {
      if (arr !== null) return arr.length;
    },
    deleteItem(name) {
      //remove asset collection association
      //remove pallet association in customers collection
      //remove from location collection
      fb.AssetsCollections.where("Discovery.Location", "==", name)
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            fb.AssetsCollections.doc(doc.id).update({
              "Discovery.Location": null
            });
          });
        });
      fb.LocationsCollections.doc(name).delete();
    },
    editItem(item) {
      this.$router.push({
        name: "location with id",
        params: { name: item.name }
      });
    }
  },
  mounted() {
    fb.LocationsCollections.onSnapshot(querySnapshot => {
      this.LocationsFromDB = [];
      querySnapshot.forEach(doc => {
        this.LocationsFromDB.push(doc.data());
      });
    });
  }
};
</script>


<style>
.iconPic {
  width: 40px;
  margin-left: 1%;
}
</style>